import { render, staticRenderFns } from "./CupcakeSlot.vue?vue&type=template&id=252e2fc9&"
import script from "./CupcakeSlot.vue?vue&type=script&lang=js&"
export * from "./CupcakeSlot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports